import { useQuery } from '@tanstack/react-query';

import { getDistributors } from '@/app/queries/get-distributors';

const useDistributorLookup = (postcode: string) => {
  return useQuery({
    queryKey: ['distributors', { postcode }],
    queryFn: getDistributors,
    throwOnError: false,
    retry: false,
    gcTime: 0,
  });
};

export { useDistributorLookup };
